import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// LIBS
import API from "../../../api";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../../lib/helpers/strings";
import { getDateFormat } from "../../../lib/helpers/dates";
import { checkBlankWithBiletHistory } from "../../../lib/helpers/history";
import { getStatusBlankString } from "../../../lib/helpers/blanks";
import { sortOnCreatedAt } from "../../../lib/helpers/sort";

// UI
import { Header, Table, VirtualDiv } from "../../../ui";
import IconArrowUpLongBold from "../../../ui/src/ui/components/icons/arrowUpLongBold";
import IconArrowDownLongBold from "../../../ui/src/ui/components/icons/arrowDownLognBold";
import IconEdit from "../../../ui/src/ui/components/icons/edit";

export default class TableBlanks extends Component {
  static propTypes = {
    biletId: PropTypes.string.isRequired,
    historysOriginal: PropTypes.arrayOf(PropTypes.shape({}))
  };

  state = {
    loading: true,
    blanks: [],
    blanksFooter: {
      countAll: 0,
      minusSum: 0,
      plusSum: 0
    }
  };

  async componentDidMount() {
    const { biletId } = this.props;

    const blanks = await API.bilets.getBiletBlanks(biletId);

    blanks.sort(sortOnCreatedAt);

    let blanksFooter = {
      countAll: 0,
      minusSum: 0,
      plusSum: 0
    };

    for (let item of blanks) {
      blanksFooter.countAll += 1;

      if (item.blank_type === "type_add") {
        blanksFooter.plusSum += item.sum;
      } else {
        blanksFooter.minusSum += item.sum;
      }
    }

    this.setState({ loading: false, blanks, blanksFooter });
  }

  getTableColumnsBlanks = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => 1 + i
      },
      {
        title: "Дата",
        suffix: "создания",
        render: ({ item }) => {
          const blankErrors = checkBlankWithBiletHistory(
            {
              createdAt: item.created_at,
              sum: item.sum
            },
            this.props.historysOriginal
          );

          return blankErrors.createdAt ? (
            <strong className="color-error">
              {getDateFormat(item.created_at)}
            </strong>
          ) : (
            getDateFormat(item.created_at)
          );
        }
      },
      {
        title: "Тип",
        suffix: "к/о",
        render: ({ item }) => {
          return (
            <VirtualDiv>
              {item.blank_type === "type_add" ? (
                <IconArrowDownLongBold className="icon-td icon-success-active" />
              ) : (
                <IconArrowUpLongBold className="icon-td icon-error" />
              )}
              {getStatusBlankString(item.blank_type)}
            </VirtualDiv>
          );
        }
      },
      {
        title: "№",
        suffix: "к/о",
        render: ({ item }) => {
          return <Link to={`/blanks/${item._id}`}>{item.blank_number}</Link>;
        }
      },
      {
        title: "Основание",
        suffix: "для к/о",
        field: "reason"
      },
      {
        title: "Сумма",
        suffix: "в к/о",
        text: "right",
        render: ({ item }) => {
          const blankErrors = checkBlankWithBiletHistory(
            {
              createdAt: item.created_at,
              sum: item.sum
            },
            this.props.historysOriginal
          );

          return (
            <VirtualDiv>
              {blankErrors.sum ? (
                <strong className="color-error">{sumFormat(item.sum)}</strong>
              ) : (
                sumFormat(item.sum)
              )}
            </VirtualDiv>
          );
        }
      },
      {
        title: "Ответсвенный",
        suffix: "за к/о",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "",
        className: "icon",
        render: ({ item }) => {
          return (
            <Link to={`/blanks/${item._id}/edit`}>
              <IconEdit />
            </Link>
          );
        }
      }
    ];
  };

  getTableBlanksFooter = () => {
    return (
      <tfoot>
        <tr>
          <td rowSpan={2}></td>
          <td rowSpan={2}>Итого</td>
          <td colSpan={2}>
            <span className="suffix">Расходных</span>
          </td>
          <td className="text-right" colSpan={2}>
            {sumFormat(this.state.blanksFooter.minusSum)}
          </td>
          <td rowSpan={2} colSpan={2}></td>
        </tr>
        <tr>
          <td colSpan={2}>
            <span className="suffix">Приходных</span>
          </td>
          <td className="text-right" colSpan={2}>
            {sumFormat(this.state.blanksFooter.plusSum)}
          </td>
        </tr>
      </tfoot>
    );
  };

  render() {
    return (
      <div>
        <Header size={4}>Кассовые ордера</Header>

        <Table
          columns={this.getTableColumnsBlanks()}
          data={this.state.blanks}
          loading={this.state.loading}
          tfoot={this.getTableBlanksFooter()}
        />
      </div>
    );
  }
}
